import { Box, Grid, Typography } from "@mui/material";
import JoinPremiumButton from "../Buttons/JoinPremiumButton/JoinPremiumButton";
import PremiumBadgeIcon from "../../img/icons/vip.png";

interface JoinPremiumPopUpNewProps {
  title?: string;
  text?: string;
}

const JoinPremiumPopUpNew = ({
  title: titleProps,
  text: textProps,
}: JoinPremiumPopUpNewProps) => {
  const title = titleProps
    ? titleProps
    : "Get insights into your collection's value with detailed graphs";
  const text = textProps
    ? textProps
    : "As a VIP member, you'll gain exclusive access to in-depth statistics about your football shirt collection. Track the total value of your shirts, compare current and original prices, analyze your collection by club, number of match worn shirts, and much more! Upgrade today and enjoy your hobby to the max!";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: "2rem",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box>
          <img
            loading="lazy"
            width="80"
            src={PremiumBadgeIcon}
            alt="Premium Vip Icon"
          />
        </Box>
        <Box>
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "1.4rem", md: "1.75rem !important" },
              color: "#3c3c40",
              fontWeight: "800 !important",
              textAlign: "center",
            }}
          >
            {title}
          </Typography>
        </Box>
      </Box>

      <Box>
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "1rem", md: "1.25rem !important" },
            color: "#3c3c40",
            fontWeight: "500 !important",
            textAlign: "center",
          }}
        >
          {text}
        </Typography>
      </Box>
      <Box sx={{ minWidth: "300px" }}>
        <JoinPremiumButton text="Upgrade" />
      </Box>
    </Box>
  );
};

export default JoinPremiumPopUpNew;
